import {
    floatingStyles,
    focusStyles,
    inputStyles,
    labelStyles
} from 'floating-label-react'

export const inputStyle = {
    floating: {
        ...floatingStyles,
        color: '#999',
        fontSize: '12px',
        borderBottomColor: '#EAEAEA',
        fontFamily: 'Geominist-Regular',
        textAlign:'center',
    },
    focus: {
        ...focusStyles,
        borderColor: '#EAEAEA',
    },
    input: {
        ...inputStyles,
        borderBottomWidth: 1,
        borderBottomColor: '#EAEAEA',
        width: '100%',
        fontSize: '16px',
        color: '#212121',
        fontFamily: 'Geominist-Regular',
        padding: '16px 0px 10px',
        marginTop: '8px',
        textAlign:'center',

    },
    label: {
        ...labelStyles,
        paddingBottom: '0px',
        marginBottom: '0px',
        flot:'center',
        width: '100%',
        fontSize: '14px',
        color: '#999',
        fontWeight:400,
        fontFamily: 'Geominist-Regular',
        textTransform: 'capitalize'
    }
}

export const inputStyleLeft = {
    floating: {
        ...floatingStyles,
        color: '#999',
        fontSize: '12px',
        borderBottomColor: '#EAEAEA',
        fontFamily: 'Geominist-Regular',
        textAlign:'left',
    },
    focus: {
        ...focusStyles,
        borderColor: '#e1e1e1',
    },
    input: {
        ...inputStyles,
        borderBottomWidth: 1,
        borderBottomColor: '#EAEAEA',
        width: '100%',
        fontSize: '16px',
        color: '#212121',
        fontFamily: 'Geominist-Regular',
        padding: '10px 0px 10px',
        marginTop: '5px',
        textAlign:'left',

    },
    label: {
        ...labelStyles,
        paddingBottom: '0px',
        marginBottom: '0px',
        flot:'left',
        width: '100%',
        fontSize: '14px',
        color: '#999',
        fontWeight:400,
        fontFamily: 'Geominist-Regular',
    }
}

export const datepicketStyle = {
    label: {
        ...labelStyles,
        paddingBottom: '0px',
        marginBottom: '0px',
        flot:'left',
        width: '100%',
        fontSize: '12px',
        color: '#999',
        fontWeight:400,
        fontFamily: 'Geominist-Regular',
    }
}
export const selectStyle = {
    label: {
        ...labelStyles,
        paddingBottom: '0px',
        marginBottom: '0px',
        flot:'left',
        width: '100%',
        fontSize: '12px',
        color: '#999',
        fontWeight:400,
        fontFamily: 'Geominist-Regular',
    }
}
export const mobileNoStyle = {
    label: {
        ...labelStyles,
        paddingBottom: '0px',
        marginBottom: '0px',
        flot:'left',
        width: '100%',
        fontSize: '12px',
        color: '#999',
        fontWeight:400,
        fontFamily: 'Geominist-Regular',
    }
}
